module.exports = __webpack_public_path__ + "img/notfound.bee9355e.jpg";